module.exports = __webpack_public_path__ + "img/data2-2.8e4e0a35.png";